<template>
    <div class="absolute w-full h-full flex-center flex-col gap-20 bg-#fff" v-if="loading">
        <template v-if="!isLoadingError">
            <img :src="Loading" class="w-50 h-50 opacity-30" />
            <span class="text-16 text-#999">{{ words || defaultWord }}</span>
        </template>
        <template v-else>
            <img :src="ErrorSvg" alt="" />
            <span class="text-16 text-#999">{{ defaultErrorWord }}</span>
        </template>
        <slot></slot>
    </div>
</template>
<script setup lang="ts">
// import loadingImg from '@/assets/imgs/loading.webp';
import { useI18n } from 'vue-i18n';
import ErrorSvg from '@/assets/svgs/error1.svg';
import Loading from '@/assets/loading.gif';
const { t } = useI18n();
const defaultWord = t('common.isLoading');
const defaultErrorWord = t('common.errorVideoTip');
withDefaults(defineProps<{
    loading: Boolean;
    words?: string;
    isLoadingError?: boolean;
}>(), { loading: true, })
</script>
<style lang="less" scoped>
.absolute .loading {
    animation: rotoImg 2s linear infinite;
}

@keyframes rotoImg {
    from {
        transform: rotate(0deg);
    }

    to {
        transform: rotate(360deg);
    }
}
</style>
